var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSafetyIcon = function SvgSafetyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m18.636 7-9.71 2.158c-.541.12-.926.6-.926 1.154v11.804a7.09 7.09 0 0 0 3.158 5.898L18.636 33l7.479-4.986a7.09 7.09 0 0 0 3.158-5.9V10.311c0-.553-.385-1.033-.926-1.153L18.637 7zm-7.428 14.872V12.15l7.428-1.644 7.429 1.644v9.723a4.23 4.23 0 0 1-1.89 3.521l-5.539 3.683-5.538-3.683a4.23 4.23 0 0 1-1.89-3.522",
    clipRule: "evenodd"
  })));
};
export default SvgSafetyIcon;